import _ from 'lodash';
import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import { BigButton, SectionTitle } from '../common/styles';
import Profile from './profile';

const Container = styled.div`
  border-radius: ${props => (props.theme.isMobile ? 150 : 200)}px 0;
  background-color: ${props => props.theme.secondaryColorLight};
  display: flex;
  flex-direction: column;
  align-items: center;
  ${props => (props.theme.isMobile ? `
    padding: 60px 20px 100px 20px;
  ` : `
    height: 708px;
  `)};
`;

const Title = styled(SectionTitle)`
  ${props => (props.theme.isMobile ? `
    text-align: center;
  ` : `
    margin-top: 104px;
  `)};
  margin-bottom: 24px;
`;

const Desc = styled.p`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 20px;
  line-height: 25px;
  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    max-width: 1004px;
    width: 70vw;
  `)};
  margin: 0;
  margin-bottom: 24px;
  text-align: center;
`;

const gradientWidth = '13vw';
const gradientHeight = '370px';
const ContributorsContainer = styled.div`
  width: 93.125vw;
  max-width: 1340px;
  display: flex;
  flex-direction: row;
  margin: 0 -${gradientWidth};
  overflow: hidden;

  &:hover {
    > div {
      animation-play-state: paused;
    }
  }
`;

const GradientContainer = styled.div`
  max-width: 1340px;
  width: 93.125vw;
  height: ${gradientHeight};
  display: flex;
  justify-content: space-between;

  &:before {
    order: -1;
    background-image: linear-gradient(
      90deg,
      ${props => props.theme.secondaryColorLight},
      ${props => props.theme.secondaryColorLight} 50%,
      transparent);
  }

  > ${ContributorsContainer} {
    order: 0;
    z-index: 100;
  }

  &:after {
    order: 1;
    background-image: linear-gradient(
      270deg,
      ${props => props.theme.secondaryColorLight},
      ${props => props.theme.secondaryColorLight} 50%,
      transparent);
    border-bottom-right-radius: 50px;
  }

  &:after, &:before {
    z-index: 150;
    content: "";
    width: ${gradientWidth};
    height: ${gradientHeight};
    max-width: 188px;
    display: block;
  }
`;

const AlignLeft = styled.div`
  display: flex;
  justify-content: start;
  overflow: hidden;
`;

const AlignRight = styled(AlignLeft)`
  padding-left: 200px;
`;

const AutoScrollContainer = styled.div`
  display: flex;

  @keyframes autoScroll {
    100% {
      transform: translateX(-100%);
    }
  }
  animation: autoScroll 40s linear infinite;
`;

const ContributorRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 60px 0;
  overflow: hidden;
`;

const MoreButton = styled(BigButton)`
  height: 60px;
  width: 140px;
  margin: 155px 160px 0px 60px;
  padding: 0;
  background-color: ${props => props.theme.btnSecondaryBackgroundColor};

  &:hover {
    background-color: ${props => props.theme.btnSecondaryHoverBackgroundColor};
  }
`;

function gotoContributorsPage() {
  window.location = '/contributors';
}

export default function Contributors() {
  const { contributors } = React.useContext(ThemeContext);

  const halfLength = contributors.length / 2;

  const firstRowProfiles = _.take(contributors, halfLength)
    .map(p => <Profile {...p} key={p.name} />);

  const secondRowProfiles = _.takeRight(contributors, contributors.length - halfLength)
    .map(p => <Profile {...p} key={p.name} />);

  return (
    <Container>
      <Title>Who contributes to Livewire</Title>
      <Desc>
        We showcase investment ideas, analysis and strategies from hundreds of Australia’s most
        credible fund managers and investment professionals – all on the one platform
      </Desc>
      <GradientContainer>
        <ContributorsContainer>
          {_.times(3, index => (
            <AutoScrollContainer key={index}>
              <ContributorRow>
                <AlignLeft>
                  {firstRowProfiles}
                </AlignLeft>
                <AlignRight>
                  {secondRowProfiles}
                </AlignRight>
              </ContributorRow>
              <MoreButton onClick={gotoContributorsPage}>
                +500 MORE
              </MoreButton>
            </AutoScrollContainer>
          ))}
        </ContributorsContainer>
      </GradientContainer>
    </Container>
  );
}
